import React, { useEffect, useState } from 'react';
import { Box, Divider, Drawer, Icon, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useMatch, useNavigate, useResolvedPath } from 'react-router-dom';

import avatar from './../../imgs/logo_hidro.png';
import { UseDrawerContext, UseAppThemeContext, useAuthContext } from '../../context';
import { CompanyServices } from '../../services/api/company/CompanyServices';

interface ISideMenuProps {
    children: React.ReactNode
}

interface IListLinkProps {
    to: string;
    label: string;
    icon: string;
    onClick: (() => void) | undefined;
}

const ListItemLink: React.FC<IListLinkProps> = ({ to, icon, label, onClick }) => {

    const navigate = useNavigate();

    const resolvedPath = useResolvedPath(to);
    const match = useMatch({ path: resolvedPath.pathname, end: false });

    const handleClick = () => {
        navigate(to);
        onClick?.();
    };

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={handleClick} selected={!!match}>
                <ListItemIcon>
                    <Icon color={'primary'} >{icon}</Icon>
                </ListItemIcon>
                <ListItemText primary={label} />
            </ListItemButton>
        </ListItem>
    );
};

export const SideMenu: React.FC<ISideMenuProps> = ({ children }) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('lg'));

    const { userData } = useAuthContext();
    const { isDrawerOpen, toggleDrawerOpen, drawerOptions, openSupportDialog } = UseDrawerContext();
    const { toggleTheme } = UseAppThemeContext();
    const { logout } = useAuthContext();
    const navigate = useNavigate();

    const [img, setImg] = useState<string>();

    const handleSupportClick = () => {
        if (userData.nivel === 'adm') {
            navigate('/support');
        } else {
            openSupportDialog();
            if (smDown) {
                toggleDrawerOpen();
            }
        }
    };


    const dark = theme.palette.primary.contrastText === '#FFFFFF';

    useEffect(() => {
        fetchData();
    }, [userData]);

    const fetchData = () => {
        if (userData !== undefined && userData.id_empresa) {
            CompanyServices.getById(userData.id_empresa)
                .then(response => {
                    if (response instanceof Error) {
                        console.log('error', response.message);
                    } else {
                        if (response.image instanceof File) {
                            setImg(undefined);
                        } else {
                            setImg(response.image);
                        }
                    }
                });
        }
    };

    const getImageSource = () => {
        if (userData.nivel === 'adm') {
            return avatar;
        } else {
            return img ? `data:image/jpeg;base64, ${img}` : avatar;
        }
    };

    return (
        <>
            <Drawer open={isDrawerOpen} variant={smDown ? 'temporary' : 'permanent'} onClose={toggleDrawerOpen}>
                <Box width={theme.spacing(28)} height={'100%'} display='flex' flexDirection='column'>
                    <Box width='100%' display='flex' alignItems='center' justifyContent='center' py={2}>
                        <Box
                            width={smDown ? '80px' : '150px'}
                            height={smDown ? '80px' : '126px'}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            bgcolor={dark ? 'white' : 'transparent'}
                            borderRadius={theme.shape.borderRadius / 2}
                            overflow="hidden"
                        >
                            <img
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain'
                                }}
                                alt="Logo da empresa"
                                src={getImageSource()}
                            />
                        </Box>
                    </Box>
                    <Divider />
                    <Box flex={1}>
                        <List component='nav'>
                            {drawerOptions.map(drawerOptions => (
                                <ListItemLink
                                    to={drawerOptions.path}
                                    key={drawerOptions.path}
                                    label={drawerOptions.label}
                                    icon={drawerOptions.icons}
                                    onClick={smDown ? toggleDrawerOpen : undefined}
                                />
                            ))}
                        </List>
                    </Box>
                    <Box>
                        <ListItem disablePadding>
                            {/* <ListItemButton onClick={toggleTheme}>
                                <ListItemIcon>
                                    <Icon color={'primary'}>contrast_icon</Icon>
                                </ListItemIcon>
                                <ListItemText primary='Alternar Tema' />
                            </ListItemButton> */}
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={handleSupportClick}>
                                <ListItemIcon>
                                    <Icon color={'primary'}>support_agent</Icon>
                                </ListItemIcon>
                                <ListItemText primary='Suporte' />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={logout}>
                                <ListItemIcon>
                                    <Icon color={'primary'}>logout</Icon>
                                </ListItemIcon>
                                <ListItemText primary='Sair' />
                            </ListItemButton>
                        </ListItem>
                        <Typography textAlign={'start'} marginLeft={1} fontSize={'0.5rem'}>version: 1.3.0</Typography>
                    </Box>
                </Box>
            </Drawer>

            <Box height='100vh' marginLeft={smDown ? 0 : theme.spacing(28)}>
                {children}
            </Box>
        </>
    );
};
